import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { ProgressBar } from 'react-bootstrap';
import Slider from "react-slick";
import useApi from '../../hook/useApi';
import Countdown from './CountDown';
import { useNavigate } from '../../hook/useNavigate';

const isDev = process.env.NODE_ENV !== 'production';
const tournamnentsUrl = isDev ? 'http://localhost:3000/tournament' : 'https://play.ztpoker.com/tournament';

const mobileSettings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const desktopSettings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
};

const UpcomingToken = () => {
    const { navNewTab } = useNavigate();
    const { data, loading } = useApi(
        'GET',
        'tournament/events',
        undefined,
        {
            refetchInterval: 1000 * 60 * 10,
        }
    );

    const tournaments = useMemo(() => {
        if (!data) {
            return null;
        }

        return data
            .filter((t) => t.state === 'enrollment')
            .sort((a, b) => a.startTime - b.startTime);
    }, [data]);

    const handleRegister = useCallback(() => {
        navNewTab(tournamnentsUrl)
    }, [navNewTab]);

    const renderTournament = useCallback((tournament, index) => {
        return (
            <div key={index}>
                <div className="upcoming-token-box">
                    <div className="d-flex justify-content-between">
                        <div className="daily-name">
                            <p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
                                    <g clipPath="url(#clip0_1_157)">
                                        <path d="M10.9375 0H4.8125C4.08789 0 3.49727 0.596094 3.52461 1.31797C3.53008 1.46289 3.53555 1.60781 3.54375 1.75H0.65625C0.292578 1.75 0 2.04258 0 2.40625C0 4.93828 0.916016 6.69922 2.14648 7.89414C3.35781 9.07266 4.83438 9.66602 5.92266 9.9668C6.5625 10.1445 7 10.6777 7 11.2137C7 11.7852 6.53516 12.25 5.96367 12.25H5.25C4.76602 12.25 4.375 12.641 4.375 13.125C4.375 13.609 4.76602 14 5.25 14H10.5C10.984 14 11.375 13.609 11.375 13.125C11.375 12.641 10.984 12.25 10.5 12.25H9.78633C9.21484 12.25 8.75 11.7852 8.75 11.2137C8.75 10.6777 9.18477 10.1418 9.82734 9.9668C10.9184 9.66602 12.3949 9.07266 13.6062 7.89414C14.834 6.69922 15.75 4.93828 15.75 2.40625C15.75 2.04258 15.4574 1.75 15.0938 1.75H12.2063C12.2145 1.60781 12.2199 1.46563 12.2254 1.31797C12.2527 0.596094 11.6621 0 10.9375 0Z" fill="#F59E0B" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1_157">
                                            <path d="M0 0H15.75V14H0V0Z" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                {tournament.type.name}
                            </p>
                            <h6>{`${tournament.prizePool} ZTGM`}</h6>
                        </div>
                        <div className='entry'>
                            <p>Entry: </p>
                            <h6>{tournament.type.buyIn === 0 ? 'Freeroll' : `${tournament.type.buyIn} ZTGM`}</h6>
                        </div>
                    </div>
                    <div className="number left-reveal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                            <g clipPath="url(#clip0_1_194)">
                                <path d="M3 1V2H1.5C0.671875 2 0 2.67188 0 3.5V5H14V3.5C14 2.67188 13.3281 2 12.5 2H11V1C11 0.446875 10.5531 0 10 0C9.44687 0 9 0.446875 9 1V2H5V1C5 0.446875 4.55312 0 4 0C3.44688 0 3 0.446875 3 1ZM14 6H0V14.5C0 15.3281 0.671875 16 1.5 16H12.5C13.3281 16 14 15.3281 14 14.5V6Z" fill="#3B82F6" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1_194">
                                    <path d="M0 0H14V16H0V0Z" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        <div style={{ marginLeft: "4px" }}>
                            <Countdown prefix={"Starting in"} timestamp={tournament.startTime} />
                        </div>
                    </div>

                    <div className="progress-box">
                        <div className='progress-text'>
                            Registered Players:
                            <span>{tournament.totalPlayers}</span>
                        </div>
                        <ProgressBar
                            now={tournament.totalPlayers}
                            min={tournament.type.minRegisteredPlayers}
                            max={tournament.type.maxRegisteredPlayers} />
                    </div>
                    <button onClick={handleRegister}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
                            <g clip-path="url(#clip0_1_184)">
                                <path d="M2.1875 1.75C1.22227 1.75 0.4375 2.53477 0.4375 3.5V5.25C0.4375 5.49062 0.639844 5.6793 0.866797 5.75859C1.38086 5.93633 1.75 6.42578 1.75 7C1.75 7.57422 1.38086 8.06367 0.866797 8.24141C0.639844 8.3207 0.4375 8.50938 0.4375 8.75V10.5C0.4375 11.4652 1.22227 12.25 2.1875 12.25H14.4375C15.4027 12.25 16.1875 11.4652 16.1875 10.5V8.75C16.1875 8.50938 15.9852 8.3207 15.7582 8.24141C15.2441 8.06367 14.875 7.57422 14.875 7C14.875 6.42578 15.2441 5.93633 15.7582 5.75859C15.9852 5.6793 16.1875 5.49062 16.1875 5.25V3.5C16.1875 2.53477 15.4027 1.75 14.4375 1.75H2.1875ZM3.9375 4.8125V9.1875C3.9375 9.42812 4.13438 9.625 4.375 9.625H12.25C12.4906 9.625 12.6875 9.42812 12.6875 9.1875V4.8125C12.6875 4.57188 12.4906 4.375 12.25 4.375H4.375C4.13438 4.375 3.9375 4.57188 3.9375 4.8125ZM3.0625 4.375C3.0625 3.89102 3.45352 3.5 3.9375 3.5H12.6875C13.1715 3.5 13.5625 3.89102 13.5625 4.375V9.625C13.5625 10.109 13.1715 10.5 12.6875 10.5H3.9375C3.45352 10.5 3.0625 10.109 3.0625 9.625V4.375Z" fill="white" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1_184">
                                    <path d="M0.4375 0H16.1875V14H0.4375V0Z" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        Register Now
                    </button>
                </div>
            </div>
        )
    }, [])

    if (loading || !tournaments) {
        return <></>
    }

    return (
        <div className="upcoming-token">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="upcoming-title">
                            <h2 className='right-reveal'>Upcoming Token Tournaments</h2>
                            <p className='right-reveal'>Compete for massive prize pools in our daily tournaments</p>
                        </div>
                    </div>
                </div>
                <div className="d-none d-md-block" style={{ marginTop: "30px" }}>
                    <div className="row row-gap-4 justify-content-center">
                        <Slider {...desktopSettings}>
                            {tournaments.map((tournament, index) => (
                                renderTournament(tournament, index)
                            ))}
                        </Slider>
                    </div>
                </div>
                <div className="row" style={{ marginTop: "10px" }}>
                    <div className="col-lg-12 d-md-none">
                        <Slider {...mobileSettings}>
                            {tournaments.map((tournament, index) => (
                                renderTournament(tournament, index)
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpcomingToken;
